'use client';

import React, { Suspense } from 'react';
import Image from "next/legacy/image";

export default function Team() {
  const teamMembers = [
    { name: 'Daniel Bonnici', 
      role: 'Owner/Builder', 
      image: '/images/dan-headshot.jpg',
      info: 'Daniel is the founder of DB Property Services with over 15 years of experience in construction and renovation.'
    },
    { name: 'Allan', 
      role: 'Builder', 
      image: '/images/al-headshot.jpg', 
      info: 'Allan is an experienced builder who brings expertise and precision to every project.' 
    },
  ];
  const bodyFont = "font-sans font-semibold";

  return (
    <section className="pt-16 pb-0 sm:pb-8 bg-white">
      <div className="container mx-auto px-4">
        <p className="text-l font-semibold text-green-600 mb-2 text-center uppercase">What we believe</p>
        <h2 className="text-4xl font-bold text-center mb-4">Your Trusted Partner for Renovations and Building Maintenance</h2>
        <p className={`${bodyFont} text-l text-gray-600 text-center mb-12 max-w-3xl mx-auto`}>
          At DB Property Services, we believe in delivering exceptional craftsmanship to the Hibiscus Coast community. Whether it’s a small repair or a large renovation, every project deserves our full attention and dedication. We believe that transforming your property should be a seamless and personal experience, tailored to your unique needs. Our commitment is to exceed your expectations with quality work, timely completion, and a focus on the details that matter most.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden relative group">
              <div className="relative h-[400px] md:h-[500px] overflow-hidden">
                <Suspense fallback={<div>Loading...</div>}>
                  <Image
                    src={member.image}
                    alt={member.name}
                    layout="fill"
                    objectFit="cover"
                    objectPosition={member.name === 'Allan' ? 'center top' : 'center'}
                    className="rounded-[80px] rounded-br-lg rounded-bl-lg"
                  />
                </Suspense>
                <div className={`${bodyFont} absolute bottom-4 left-4 right-4 text-center bg-white bg-opacity-80 px-3 py-2 rounded-lg shadow-md`}>
                  <span className="text-sm font-semibold text-gray-800">{member.name}</span>
                  <span className="text-xs text-gray-600 ml-2">{member.role}</span>
                </div>
              </div>
              <div className="absolute inset-0 rounded-tr-[80px] rounded-tl-[80px] bg-black bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-lg transition-opacity duration-300">
                <p className={`${bodyFont} text-white text-center p-4`}>{member.info}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
